import { Tooltip } from "@mantine/core";
import { ReactNode } from "react";

interface Props {
  label: string | undefined;
  children: ReactNode; // This is the key part
}
export const EbTooltip: React.FC<Props> = ({ children, label }) => {
  return (
    <Tooltip
      events={{ hover: true, focus: true, touch: true }}
      label={label}
      multiline
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          pointerEvents: "auto",
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
